import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// 添加文件名截断函数
export function truncateFilename(
  filename: string,
  maxLength: number = 50,
): string {
  if (filename.length <= maxLength) {
    return filename;
  }

  // 保留文件扩展名
  const lastDotIndex = filename.lastIndexOf('.');
  if (lastDotIndex === -1) {
    // 没有扩展名的情况
    return filename.substring(0, maxLength - 3) + '...';
  }

  const name = filename.substring(0, lastDotIndex);
  const extension = filename.substring(lastDotIndex);

  // 确保至少保留3个字符在省略号前
  const minPrefixLength = 3;

  // 计算文件名部分的最大长度
  const maxNameLength = Math.max(
    minPrefixLength,
    maxLength - extension.length - 3,
  );

  if (name.length <= maxNameLength) {
    return filename;
  }

  // 保留前缀和后缀，中间用省略号替代
  const prefixLength = Math.max(minPrefixLength, Math.floor(maxNameLength / 2));
  const suffixLength = Math.max(0, maxNameLength - prefixLength - 3); // 3 是省略号的长度

  const prefix = name.substring(0, prefixLength);
  const suffix =
    suffixLength > 0 ? name.substring(name.length - suffixLength) : '';

  return prefix + '...' + suffix + extension;
}

export function extractHeadings(markdown: string) {
  const headings = [];
  const lines = markdown.split('\n');

  for (let line of lines) {
    line = line.trim();
    const match = line.match(/^(#{1,6})\s+(.*)/);
    if (match) {
      const level = match[1].length; // 标题级别，1 为 h1，2 为 h2 等
      const title = match[2].trim(); // 标题文本
      headings.push({ level, title });
    }
  }

  return headings;
}
